export default "__VITE_ASSET__a4654d88__"